export default __webpack_public_path__ + "static/media/Screenshot (1140).adc20232.png";